import { ApplicationState } from "./state";
import { Store, createStore, applyMiddleware } from "redux";
import Reducers from './index';
 
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';


//const sagaMiddleware = createSagaMiddleware()
const composeEnhancers = composeWithDevTools({})


export const store: Store<ApplicationState> = createStore(
    Reducers as any,
    composeEnhancers(applyMiddleware(thunk)) as any
   // (window as any).__REDUX_DEVTOOLS_EXTENSION__  && (window as any).__REDUX_DEVTOOLS_EXTENSION__(applyMiddleware(sagaMiddleware))
    );





